import * as Types from '../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const DiseaseEncyclopediaByUserDocument = `
    query DiseaseEncyclopediaByUser($diseaseEncyclopediaPid: ID!) {
  diseaseEncyclopediaByUser(diseaseEncyclopediaPid: $diseaseEncyclopediaPid) {
    bottomButtonType
    content
    departmentTags
    id
    publicId
    searchTags
    title
    titleImageUrl
    symptomTags
    banner {
      buttonPhrase
      description
      diseaseEncyclopediaId
      externalUrl
      id
      imageUrl
      title
    }
    faqs {
      question
      answer
    }
  }
}
    `;
export const useDiseaseEncyclopediaByUserQuery = <
      TData = Types.DiseaseEncyclopediaByUserQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.DiseaseEncyclopediaByUserQueryVariables,
      options?: UseQueryOptions<Types.DiseaseEncyclopediaByUserQuery, TError, TData>,
    ) =>
    useQuery<Types.DiseaseEncyclopediaByUserQuery, TError, TData>(
      ['DiseaseEncyclopediaByUser', variables],
      gqlFetcher<Types.DiseaseEncyclopediaByUserQuery, Types.DiseaseEncyclopediaByUserQueryVariables>(DiseaseEncyclopediaByUserDocument, 'DiseaseEncyclopediaByUser', variables),
      options
    );

useDiseaseEncyclopediaByUserQuery.getKey = (variables: Types.DiseaseEncyclopediaByUserQueryVariables) => ['DiseaseEncyclopediaByUser', variables];
;

useDiseaseEncyclopediaByUserQuery.fetcher = (variables: Types.DiseaseEncyclopediaByUserQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.DiseaseEncyclopediaByUserQuery, Types.DiseaseEncyclopediaByUserQueryVariables>(DiseaseEncyclopediaByUserDocument, 'DiseaseEncyclopediaByUser', variables, options);